import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Whether email notifications are enabled.
 */
export const schema = z.boolean();

export type AllowEmailNotifications = z.infer<typeof schema>;

export const definition = define({
  key: 'allow_email_notifications',
  schema,
  label: 'Move Status Updates',
  description:
    'Select whether clients at this level prefer their users to receive email notifications when a move has been picked up or delivered successfully. If selected, the user who created the move, as well as an optional list of other users specified during move planning, will receive a notification via email.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.NOTIFICATIONS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: false,
});
